import Div from "@jumbo/shared/Div";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import InfoIcon from "@mui/icons-material/Info";
import SearchIcon from "@mui/icons-material/Search";
import { LoadingButton } from "@mui/lab";
import {
  Button,
  Checkbox,
  Chip,
  InputAdornment,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  TextareaAutosize,
  Typography,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { getPortListNoPerm } from "app/services/apis/ListApi/portListNoPerm";
import { getLatestDispatchId } from "app/services/apis/OrderApis/getLatestDispatchId";
import {
  currentdate,
  dateFun,
  displayDateFun,
} from "app/utils/constants/functions";
import axios from "axios";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { CuttingListInfoModal } from "../../Cutter/List/cuttingListInfoModal";
import ReceiveOrderDetailsModal from "../../Receive/List/receiveOrderDetails";
import NormalAddonsModal from "./normalOrderAddons";
const label = { inputProps: { "aria-label": "Checkbox demo" } };

const CreateNewDispatch = () => {
  const [portNoNameList, setPortNoNameList] = useState([]);
  const [orderDeatailModal, setOrderDeatailModal] = useState("");
  const [isInfoModalOpen, setInfoModalOpen] = useState(false);
  const [isAddonsModalOpen, setAddonsModalOpen] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [submitLoader, setSubmitLoader] = useState(false);
  const [order, setOrder] = useState("");
  const [orderBy, setOrderBy] = useState("fabric_code");
  const [orderData, setOrderData] = useState([]);
  const [itemDetails, setItemDetails] = useState([]);
  const [emptyAddons, setEmptyAddons] = useState([]);
  const [itemIndex, setItemIndex] = useState(null);
  const [selectedPort, setSelectedPort] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [dispatchId, setDispatchId] = useState(0);
  const [inputs, setInputs] = useState({
    dispatch_type: "Normal Order",
    dispatch_order_status: "",
    dispatch_port_no_and_name: "",
    dispatch_shipment_no: "",
    transport_type: "",
    awb_bl_no: "",
    dispatch_date: dateFun(currentdate),
    dispatch_box_no: "",
    dispatch_weight: "",
    dispatch_quantity: itemDetails.length,
    dispatch_est_delivery_date: dateFun(currentdate),
    dispatch_contact_person_name: "",
    dispatch_contact_person_phone_no: "",
  });
  const navigate = useNavigate();
  // console.log(orderData);
  const handleChange = (event) => {
    // console.log(event, "tttttttttttttt");
    const name = event.target.name;
    const value = event.target.value;
    if (name === "dispatch_port_no_and_name") {
      setOrderData([]);
      setSelectedPort(value);
    }
    if (name === "dispatch_type") {
      setSelectedPort("");
    }
    setInputs((values) => ({
      ...values,
      [name]: name === "dispatch_weight" ? parseFloat(value) : value,
    }));
  };

  const sortedData = orderData?.sort((a, b) => {
    const aValue = a[orderBy];
    const bValue = b[orderBy];
    if (order === "desc") {
      return aValue < bValue ? -1 : 1;
    } else {
      return bValue < aValue ? -1 : 1;
    }
  });

  const handleModal = (row, type, index) => {
    if (type === "addons") {
      setSelectedRowData(row);
      setItemIndex(index);
      setAddonsModalOpen(true);
    } else {
      if (row.order_item_status === "New Order") {
        setOrderDeatailModal("New Order");
        setSelectedRowData(row);
        setInfoModalOpen(true);
      } else {
        setOrderDeatailModal("");
        setSelectedRowData(row);
        setInfoModalOpen(true);
      }
    }
  };
  // const handleSelect = (e, data, rowIndex, type) => {
  //   if (type !== "shop") {
  //     if (e.target.checked !== true) {
  //       let updatedItemDetails = [...itemDetails];
  //       let removeItemIndex = updatedItemDetails?.findIndex((item) => {
  //         return item?.order_items_id === orderData[rowIndex]?.order_items_id;
  //       });
  //       // updatedItemDetails[removeItemIndex] = undefined; // old set index value as undefined

  //       updatedItemDetails?.splice(removeItemIndex, 1)

  //       setItemDetails(updatedItemDetails);
  //     } else {
  //       const updatedItemDetails = [...itemDetails];

  //       let finalupdatedItemDetails = {
  //         order_items_id: data.order_items_id,
  //         orders_id: data.orders_id,
  //         dispatch_addons_items:
  //           data.addons_items.length > 0
  //             ? data.addons_items.map((ele, i, arr) => {
  //               return {
  //                 ...arr[i],
  //                 // dispatch_quantity: 0, // old code where default dispatch qty is 0
  //                 dispatch_quantity: ele?.addons_quantity, // default dispatch qty set as required qty
  //               };
  //             })
  //             : [],
  //       };
  //       setItemDetails([...updatedItemDetails, finalupdatedItemDetails]);
  //     }
  //   } else {
  //     console.log(itemDetails)
  //     if (e.target.value === "") {
  //       const updatedItemDetails = [...itemDetails];
  //       updatedItemDetails[rowIndex] = null;
  //       setItemDetails(updatedItemDetails);
  //     } else {
  //       const updatedItemDetails = [...itemDetails];
  //       updatedItemDetails[rowIndex] = {
  //         shop_order_items_id: data?.shop_order_items_id,
  //         shop_order_id: data?.shop_order_id,
  //         shop_order_item_size: data.shop_order_item_size,
  //         shop_order_item_name: data.shop_order_item_name,
  //         dispatch_quantity: Number(e.target.value),
  //         require_quantity: data?.shop_order_item_require_quantity,
  //         balance_quantity: data?.balance_quantity,
  //       };
  //       setItemDetails(updatedItemDetails);
  //     }
  //   }
  // }; //previous logic
  const handleSelect = (e, data, rowIndex, type) => {
    if (type !== "shop") {
      if (e.target.checked !== true) {
        let updatedItemDetails = [...itemDetails];
        let removeItemIndex = updatedItemDetails?.findIndex((item) => {
          return item?.order_items_id === orderData[rowIndex]?.order_items_id;
        });
        // updatedItemDetails[removeItemIndex] = undefined; // old set index value as undefined

        updatedItemDetails?.splice(removeItemIndex, 1)

        setItemDetails(updatedItemDetails);
      } else {
        const updatedItemDetails = [...itemDetails];

        let finalupdatedItemDetails = {
          order_items_id: data.order_items_id,
          orders_id: data.orders_id,
          dispatch_addons_items:
            data.addons_items.length > 0
              ? data.addons_items.map((ele, i, arr) => {
                return {
                  ...arr[i],
                  // dispatch_quantity: 0, // old code where default dispatch qty is 0
                  dispatch_quantity: ele?.addons_quantity, // default dispatch qty set as required qty
                };
              })
              : [],
        };
        setItemDetails([...updatedItemDetails, finalupdatedItemDetails]);
      }
    } else {
      if (e.target.value === "") {
        const updatedItemDetails = [...itemDetails];
        updatedItemDetails[rowIndex] = null;
        setItemDetails(updatedItemDetails);
      } else {
        const updatedItemDetails = [...itemDetails];
        updatedItemDetails[rowIndex] = {
          shop_order_items_id: data?.shop_order_items_id,
          shop_order_id: data?.shop_order_id,
          shop_order_item_size: data.shop_order_item_size,
          shop_order_item_name: data.shop_order_item_name,
          dispatch_quantity: Number(e.target.value),
          require_quantity: data?.shop_order_item_require_quantity,
          balance_quantity: data?.balance_quantity,
          inventory_status: false,
          is_dispatch: false
        };
        setItemDetails(updatedItemDetails);
      }
    }
  };

  const submitForm = async () => {
    let body = {};
    if (inputs?.dispatch_type === "Normal Order") {
      body = {
        ...inputs,
        dispatch_quantity: itemDetails.length,
        dispatch_id: dispatchId,
        dispatch_items: itemDetails
          .filter((item) => typeof item == "object" && item !== null)
          .map((item) => ({
            ...item,
            dispatch_addons_items: item?.dispatch_addons_items?.filter(
              (addon) => addon !== null
            ),
          })),
      };
    } else {
      body = {
        dispatch_type: inputs?.dispatch_type,
        shop_order_dispatch_port_no_and_name: inputs.dispatch_port_no_and_name,
        shop_order_transport_type: inputs.transport_type,
        shop_order_awb_bl_no: inputs.awb_bl_no,
        shop_order_dispatch_date: inputs.dispatch_date,
        shop_order_dispatch_box_no: inputs?.dispatch_box_no,
        shop_order_dispatch_weight: inputs.dispatch_weight,
        shop_order_dispatch_contact_person_name:
          inputs.dispatch_contact_person_name,
        shop_order_dispatch_contact_person_phone_no:
          inputs.dispatch_contact_person_phone_no,
        shop_order_dispatch_est_delivery_date:
          inputs.dispatch_est_delivery_date,
        shop_order_dispatch_quantity: itemDetails
          ?.filter((item) => item !== null)
          .reduce((a, item) => {
            return a + (item?.dispatch_quantity || 0);
          }, 0),
        shop_order_dispatch_id: dispatchId,
        dispatch_shipment_no: inputs.dispatch_shipment_no,
        dispatch_items: itemDetails.filter(
          // (item) => typeof item == "object" && item !== null //previous logic
          (item) => typeof item == "object" && item !== null && item?.is_dispatch === true
        ),
      };
    }
    try {
      setSubmitLoader(true);
      const config = {
        withCredentials: true,
        headers: {
          withCredentials: true,
        },
      };
      if (inputs.dispatch_type === "Normal Order") {
        const data = await axios.post(
          `${process.env.REACT_APP_URL}/api/dispatch/add-dispatch`,
          body,
          config
        );
        if (data?.status === 200) {
          Swal.fire({ icon: "success", title: "Dispatch Created" });
          navigate("/dashboard/order/dispatch");
        }
      } else {
        const data = await axios.post(
          `${process.env.REACT_APP_URL}/api/shop-order-dispatch/add-shop-order-dispatch`,
          body,
          config
        );
        if (data?.status === 200) {
          Swal.fire({ icon: "success", title: "Dispatch Created" });
          sessionStorage.removeItem("shopOrderItemDispatch")
          navigate("/dashboard/order/dispatch");
        }
      }
    } catch (error) {
      Swal.fire({ icon: "error", title: error?.response?.data?.message });
    } finally {
      setSubmitLoader(false);
    }
  };

  useEffect(() => {
    (async () => {
      setPortNoNameList(await getPortListNoPerm());
    })()
  }, []);

  useEffect(() => {
    (async () => {
      if (selectedPort !== "") {
        setItemDetails([]);
        try {
          const config = {
            withCredentials: true,
            headers: {
              withCredentials: true,
            },
          };
          if (inputs?.dispatch_type === "Normal Order") {
            const data = await axios.get(
              `${process.env.REACT_APP_URL}/api/dispatch/list-partial-and-completed?order_port_no_and_name=${selectedPort}`,
              config
            );
            if (data?.status === 200) {
              setOrderData(data.data.result);
            }
          } else {
            const data = await axios.get(
              `${process.env.REACT_APP_URL}/api/list-order/get-all-shop-order-status-in-dispatch?shop_order_port_no_and_name=${selectedPort}`,
              config
            );
            if (data?.status === 200) {
              setOrderData(data.data.result);
              const itemDetails = data.data.result?.map((ele) => {
                return {
                  shop_order_items_id: ele?.shop_order_items_id,
                  shop_order_id: ele?.shop_order_id,
                  shop_order_item_size: ele.shop_order_item_size,
                  shop_order_item_name: ele.shop_order_item_name,
                  dispatch_quantity: 0,
                  require_quantity: ele?.shop_order_item_require_quantity,
                  balance_quantity: ele?.balance_quantity,
                  inventory_status: false,
                  is_dispatch: false
                }
              })
              setItemDetails(itemDetails);
            }
          }
        } catch (error) {
          // console.log(error?.response?.data?.result);
        }
      }
    })()
  }, [selectedPort]);

  // console.log(itemDetails, "jtyh");

  const handleSearch = async (value) => {
    if (inputs?.dispatch_type == "Normal Order") {
      const config = {
        withCredentials: true,
        headers: {
          withCredentials: true,
        },
      };
      const data = await axios.get(
        `${process.env.REACT_APP_URL}/api/dispatch/list-partial-and-completed?order_port_no_and_name=${selectedPort}&search=${value}`,
        config
      );
      if (data?.status === 200) {
        // if (
        //   itemDetails.length > 0 &&
        //   !itemDetails.every((item) => item == undefined)
        // ) {
        //   const index = data.data.result.findIndex(item => item.order_items_id === );
        // }
        // console.log(data.data.result, "ressss");
        setOrderData(data.data.result);
      }
    }
  };

  useEffect(() => {
    (async () => {
      if (inputs.dispatch_type === "Normal Order") {
        setItemDetails([]);
        setDispatchId(await getLatestDispatchId());
      } else {
        setItemDetails([]);
        setDispatchId(await getLatestDispatchId("shop"));
      }
      setOrderData([]);
      setItemDetails([]);
      setInputs({ ...inputs, dispatch_port_no_and_name: "" });
    })()
  }, [inputs?.dispatch_type]);


  // check inventory shop order logic

  const handleInventoryCheck = async function (rowData, index) {
    try {
      // const data = itemDetails.find((ele) => ele.shop_order_items_id === rowData.shop_order_items_id && ele.shop_order_id === rowData?.shop_order_id);
      const itemData = itemDetails?.[index];

      if (itemData) {
        const config = {
          withCredentials: true,
          headers: {
            withCredentials: true,
          },
        };
        const item_name = itemData.shop_order_item_name;
        const item_size = itemData.shop_order_item_size;
        const dispatch_quantity = itemData.dispatch_quantity;

        const reponse = await axios.post(
          `${process.env.REACT_APP_URL}/api/shop-order-dispatch/check-shop-order-inventory`,
          {
            itemName:item_name, 
            itemSize:item_size,
            dispatch_quantity: dispatch_quantity
          },
          config
        );
        const result = reponse?.data;
        if (result?.available) {
          const updatedItemDetails = [...itemDetails];
          updatedItemDetails[index] = {
            ...updatedItemDetails[index],
            inventory_status: true,
            is_dispatch: true,
            shop_order_finished_item_id:result?.result?.id,
            cancel_details: {
              id: result?.result?.id,
              dispatch_quantity: dispatch_quantity,
            }
          };
          setItemDetails(updatedItemDetails);
          const shopOrderItemDispatch = sessionStorage.getItem("shopOrderItemDispatch")
          const latestShopOrderItemDispatchData = {
            id: result?.result?.id,
            dispatch_quantity: dispatch_quantity,
          }
          if (shopOrderItemDispatch) {
            const shopOrderItemDispatchData = JSON.parse(shopOrderItemDispatch)
            const updatedShopOrderItemDispatch = [...shopOrderItemDispatchData, latestShopOrderItemDispatchData]
            sessionStorage.setItem("shopOrderItemDispatch", JSON.stringify(updatedShopOrderItemDispatch))
          } else {
            sessionStorage.setItem("shopOrderItemDispatch", JSON.stringify([latestShopOrderItemDispatchData]))
          }
        }
      }

    } catch (error) {
      console.log(error)
      Swal.fire({
        position: "center",
        icon: "error",
        title: error?.response?.data?.message,
        showConfirmButton: false,
        timer: 1500,
      });
    }
  }

  const handleInventoryEdit = async function (rowData, index) {
    const itemData = itemDetails?.[index];
    try {
      if (itemData) {
        const config = {
          withCredentials: true,
          headers: {
            withCredentials: true,
          },
        };

        const res = await axios.post(
          `${process.env.REACT_APP_URL}/api/shop-order-dispatch/revert-shop-order-inventory`,
          {
            items: [itemData?.cancel_details]
          },
          config
        );
        if(res?.status === 200 && res?.data?.status){
          const updatedItemDetails = [...itemDetails];
          updatedItemDetails[index] = {
            ...updatedItemDetails[index],
            inventory_status: false,
            is_dispatch: false,
          };
          setItemDetails(updatedItemDetails);
          const shopOrderItemDispatch = sessionStorage.getItem("shopOrderItemDispatch")
          if (shopOrderItemDispatch) {
            const shopOrderItemDispatchData = JSON.parse(shopOrderItemDispatch)
            const updatedShopOrderItemDispatch = shopOrderItemDispatchData?.filter((ele) => ele.id !== itemData?.cancel_details?.id);
            sessionStorage.setItem("shopOrderItemDispatch", JSON.stringify(updatedShopOrderItemDispatch))
          }
        }
      }
    } catch (error) {
      console.error(error);
      // Handle the error as needed
    }
  }

  const revertInventory = async () => {
    const restoringInventory = JSON.parse(sessionStorage.getItem("shopOrderItemDispatch"));
    sessionStorage.removeItem("shopOrderItemDispatch");
    if (restoringInventory) {
      try {
        const config = {
          withCredentials: true,
          headers: {
            withCredentials: true,
          },
        };

        const res = await axios.post(
          `${process.env.REACT_APP_URL}/api/shop-order-dispatch/revert-shop-order-inventory`,
          { items: restoringInventory },
          config
        );
      } catch (error) {
        console.error(error);
        // Handle the error as needed
      }
    }
  };

  useEffect(() => {
    // Handle page unload (closing the tab/window)

    window.addEventListener("beforeunload", revertInventory);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("beforeunload", revertInventory);
    };
  }, []); // Empty dependency array to run this effect only once on component mount

  useEffect(() => {
    // Handle page refresh

    // Run the refresh handling logic when the component mounts
    revertInventory();

    return function(){
      revertInventory();
    }
  }, [inputs?.dispatch_type, selectedPort]); // Empty depe

  return (
    <Div>
      <Typography variant="h1" sx={{ mt: -4, mb: 3 }}>
        Create New Dispatch
      </Typography>
      <Div sx={{ display: "flex", columnGap: 5, mb: 5 }}>
        <Div sx={{ width: "23%" }}>
          <Typography variant="h5">Dispatch Type</Typography>
          <Select
            size="small"
            sx={{ width: "100%" }}
            name="dispatch_type"
            onChange={handleChange}
            value={inputs?.dispatch_type}
          >
            <MenuItem value={"Normal Order"}>{"Normal Order"}</MenuItem>
            <MenuItem value={"Shop Order"}>{"Shop Order"}</MenuItem>
          </Select>
        </Div>
        <Div sx={{ width: "23%" }}>
          <Typography variant="h5">Select Port</Typography>
          <Select
            size="small"
            sx={{ width: "100%" }}
            name="dispatch_port_no_and_name"
            value={inputs?.dispatch_port_no_and_name}
            onChange={handleChange}
          >
            {portNoNameList?.map((item) => {
              return <MenuItem value={item}>{item}</MenuItem>;
            })}
          </Select>
        </Div>
        {inputs?.dispatch_type == "Normal Order" &&
          inputs?.dispatch_port_no_and_name != "" && (
            <Div sx={{ mt: 3.3 }}>
              <TextField
                size="small"
                id="search"
                type="search"
                label="Search"
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  handleSearch(e.target.value);
                }}
                sx={{ width: 300, mt: "auto" }}
                InputProps={{
                  endAdornment: (
                    <Div sx={{ cursor: "pointer" }}>
                      <InputAdornment position="end">
                        <SearchIcon />
                      </InputAdornment>
                    </Div>
                  ),
                }}
              />
            </Div>
          )}
        {/* <Div sx={{ width: "23%" }}>
          <Typography variant="h5">Order Status</Typography>
          <Select
            size="small"
            sx={{ width: "100%" }}
            name="dispatch_order_status"
            onChange={handleChange}
            value={inputs?.dispatch_order_status}
          >
            <MenuItem value={"Complete Order"}>{"Complete Order"}</MenuItem>
            <MenuItem value={"Partial Order"}>{"Partial Order"}</MenuItem>
          </Select>
        </Div> */}
      </Div>
      {orderData.length > 0 && (
        <>
          {inputs?.dispatch_type === "Normal Order" ? (
            <Div>
              <Div sx={{ width: "100%", bgcolor: "black" }}>
                <Typography
                  variant="h4"
                  sx={{
                    bgcolor: "#202020",
                    color: "white",
                    p: 1,
                    mb: "-2",
                  }}
                >
                  {inputs.dispatch_port_no_and_name}
                </Typography>
              </Div>

              <TableContainer component={Paper} sx={{ height: "50vh" }}>
                <Table>
                  <TableHead sx={{ position: "sticky", top: 0, zIndex: "2" }}>
                    <TableRow sx={{ bgcolor: "#202020", color: "white" }}>
                      <TableCell
                        sx={{
                          textAlign: "left",
                          minWidth: "90px",
                          verticalAlign: "middle",
                          color: "white",
                        }}
                      >
                        Select
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "left",
                          minWidth: "160px",
                          verticalAlign: "middle",
                          color: "white",
                        }}
                      >
                        Status
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "left",
                          minWidth: "120px",
                          verticalAlign: "middle",
                          color: "white",
                        }}
                      >
                        Order No
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "left",
                          minWidth: "120px",
                          verticalAlign: "middle",
                          color: "white",
                        }}
                      >
                        Item No.
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "left",
                          minWidth: "130px",
                          verticalAlign: "middle",
                          color: "white",
                        }}
                      >
                        Item Name
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "left",
                          minWidth: "160px",
                          verticalAlign: "middle",
                          color: "white",
                        }}
                      >
                        Sub Item Name
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "left",
                          minWidth: "135px",
                          verticalAlign: "middle",
                          color: "white",
                        }}
                      >
                        Job Work ID
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "left",
                          minWidth: "120px",
                          verticalAlign: "middle",
                          color: "white",
                        }}
                      >
                        AddOns
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "left",
                          minWidth: "120px",
                          verticalAlign: "middle",
                          color: "white",
                        }}
                      >
                        Order Details
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "left",
                          minWidth: "100px",
                          verticalAlign: "middle",
                          color: "white",
                        }}
                      >
                        Factory
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "left",
                          minWidth: "130px",
                          verticalAlign: "middle",
                          color: "white",
                        }}
                      >
                        Order Date
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "left",
                          minWidth: "170px",
                          verticalAlign: "middle",
                          color: "white",
                        }}
                      >
                        Exp. Delivery Date
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody
                    sx={{
                      height: "10vh",
                      overflowY: "scroll",
                      "&::-webkit-scrollbar": {
                        width: "12px",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "#6b6b6b",
                        borderRadius: "2px",
                      },
                      "&::-webkit-scrollbar-track": {
                        backgroundColor: "#d4d4d4",
                        borderRadius: "1px",
                      },
                    }}
                  >
                    {sortedData?.map((row, i) => (
                      <TableRow
                        key={i}
                        sx={{
                          bgcolor:
                            emptyAddons?.includes(
                              row?.order_item_job_work_id
                            ) && "#ef233c !important",
                        }}
                      >
                        <TableCell
                          sx={{
                            textAlign: "left",
                          }}
                        >
                          {/* {console.log(row)} */}
                          {/* {console.log(itemDetails)} */}
                          <Checkbox
                            {...label}
                            sx={{
                              color:
                                emptyAddons?.includes(
                                  row?.order_item_job_work_id
                                ) && "#FFFF !important",
                            }}
                            onChange={(e) => handleSelect(e, row, i)}
                            checked={itemDetails?.some(
                              (item) =>
                                item?.order_items_id === row?.order_items_id
                            )}
                          />
                        </TableCell>
                        <TableCell>
                          <Chip
                            color={
                              row?.order_status === "Completed"
                                ? "success"
                                : "warning"
                            }
                            size={"small"}
                            label={row?.order_status}
                          />
                        </TableCell>

                        {/* <TableCell>{row.order_status}</TableCell> */}
                        <TableCell
                          sx={{
                            textAlign: "left",
                            color:
                              emptyAddons?.includes(
                                row?.order_item_job_work_id
                              ) && "#FFFF !important",
                          }}
                        >
                          {row.order_no}
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: "left",
                            color:
                              emptyAddons?.includes(
                                row?.order_item_job_work_id
                              ) && "#FFFF !important",
                          }}
                        >
                          {row.order_item_no}
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: "left",
                            color:
                              emptyAddons?.includes(
                                row?.order_item_job_work_id
                              ) && "#FFFF !important",
                          }}
                        >
                          {row.order_item_name}
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: "left",
                            color:
                              emptyAddons?.includes(
                                row?.order_item_job_work_id
                              ) && "#FFFF !important",
                          }}
                        >
                          {row.order_sub_item_name
                            ? row.order_sub_item_name
                            : "-"}
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: "left",
                            color:
                              emptyAddons?.includes(
                                row?.order_item_job_work_id
                              ) && "#FFFF !important",
                          }}
                        >
                          {row.order_item_job_work_id
                            ? row.order_item_job_work_id
                            : "-"}
                        </TableCell>
                        <TableCell sx={{ textAlign: "left", pl: "3%" }}>
                          <ControlPointIcon
                            sx={{
                              cursor: "pointer",
                              color:
                                emptyAddons?.includes(
                                  row?.order_item_job_work_id
                                ) && "#FFFF !important",
                            }}
                            onClick={() => {
                              // console.log(itemDetails, row?.order_items_id);
                              if (
                                itemDetails?.some(
                                  (item) =>
                                    item &&
                                    item?.order_items_id === row?.order_items_id
                                )
                              ) {
                                handleModal(row, "addons", i);
                              } else {
                                return Swal.fire({
                                  icon: "warning",
                                  text: "Select Item",
                                });
                              }
                            }}
                          />
                        </TableCell>
                        <TableCell sx={{ textAlign: "left", pl: "3%" }}>
                          <InfoIcon
                            sx={{
                              cursor: "pointer",
                              color:
                                emptyAddons?.includes(
                                  row?.order_item_job_work_id
                                ) && "#FFFF !important",
                            }}
                            onClick={() => handleModal(row)}
                          />
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: "left",
                            color:
                              emptyAddons?.includes(
                                row?.order_item_job_work_id
                              ) && "#FFFF !important",
                          }}
                        >
                          {row.order_item_factory_name}
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: "left",
                            color:
                              emptyAddons?.includes(
                                row?.order_item_job_work_id
                              ) && "#FFFF !important",
                          }}
                        >
                          {displayDateFun(row.order_date)}
                        </TableCell>
                        <TableCell sx={{ textAlign: "left" }}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              disabled
                              format="DD/MM/YY"
                              defaultValue={dayjs(row.order_est_delivery_date)}
                              sx={{
                                width: "100%",
                                "&.MuiTextField-root": {
                                  height: "39px",
                                  flexDirection: "unset",
                                },
                              }}
                            />
                          </LocalizationProvider>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                {orderDeatailModal == "New Order" ? (
                  <CuttingListInfoModal
                    open={isInfoModalOpen}
                    onClose={() => {
                      setInfoModalOpen(false);
                    }}
                    rowData={selectedRowData}
                  />
                ) : (
                  <ReceiveOrderDetailsModal
                    open={isInfoModalOpen}
                    onClose={() => setInfoModalOpen(false)}
                    rowData={selectedRowData}
                  />
                )}
                <NormalAddonsModal
                  itemDetails={itemDetails}
                  setItemDetails={setItemDetails}
                  index={itemIndex}
                  open={isAddonsModalOpen}
                  onClose={() => setAddonsModalOpen(false)}
                  rowData={selectedRowData}
                />
              </TableContainer>
            </Div>
          ) : (
            <Div>
              <Div sx={{ width: "100%", bgcolor: "black" }}>
                <Typography
                  variant="h4"
                  sx={{
                    bgcolor: "#202020",
                    color: "white",
                    p: 1,
                    mb: "-2",
                  }}
                >
                  {inputs.dispatch_port_no_and_name}
                </Typography>
              </Div>
              <TableContainer
                component={Paper}
                sx={{ height: "50vh", overflowY: "scroll" }}
              >
                <Table>
                  <TableHead sx={{ position: "sticky", top: 0, zIndex: "2" }}>
                    <TableRow
                      sx={{ bgcolor: "#202020", color: "white", width: "100%" }}
                    >
                      <TableCell
                        sx={{
                          textAlign: "left",
                          minWidth: "7%",
                          verticalAlign: "middle",
                          color: "white",
                        }}
                      >
                        Select
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "left",
                          minWidth: "7%",
                          verticalAlign: "middle",
                          color: "white",
                        }}
                      >
                        Order No
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "left",
                          minWidth: "7%",
                          verticalAlign: "middle",
                          color: "white",
                        }}
                      >
                        Item No
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "left",
                          minWidth: "7%",
                          verticalAlign: "middle",
                          color: "white",
                        }}
                      >
                        Item Name
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "left",
                          minWidth: "7%",
                          verticalAlign: "middle",
                          color: "white",
                        }}
                      >
                        Item Size
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "left",
                          minWidth: "7%",
                          verticalAlign: "middle",
                          color: "white",
                        }}
                      >
                        Item Unit
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "left",
                          minWidth: "140px",
                          verticalAlign: "middle",
                          color: "white",
                        }}
                      >
                        Dispatch Qty
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "left",
                          minWidth: "140px",
                          verticalAlign: "middle",
                          color: "white",
                        }}
                      >
                        Inventory Check
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "left",
                          minWidth: "7%",
                          verticalAlign: "middle",
                          color: "white",
                        }}
                      >
                        Required Qty
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "left",
                          minWidth: "7%",
                          verticalAlign: "middle",
                          color: "white",
                        }}
                      >
                        Balance Qty
                      </TableCell>
                      {/* <TableCell
                        sx={{
                          textAlign: "left",
                          minWidth: "7%",
                          verticalAlign: "middle",
                          color: "white",
                        }}
                      >
                        Available Qty
                      </TableCell> */}
                      <TableCell
                        sx={{
                          textAlign: "left",
                          minWidth: "7%",
                          verticalAlign: "middle",
                          color: "white",
                        }}
                      >
                        Item Remark
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "left",
                          minWidth: "7%",
                          verticalAlign: "middle",
                          color: "white",
                        }}
                      >
                        Main Remark
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "left",
                          minWidth: "7%",
                          verticalAlign: "middle",
                          color: "white",
                        }}
                      >
                        Client Name
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "left",
                          minWidth: "120px",
                          verticalAlign: "middle",
                          color: "white",
                        }}
                      >
                        Order Date
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {sortedData?.map((row, i) => (
                      <TableRow key={i}>
                        <TableCell sx={{ textAlign: "left" }}>
                          <Checkbox
                            {...label}
                            // checked={itemDetails[i] != null ? true : false}
                            checked={itemDetails?.[i]?.is_dispatch === true}
                          />
                        </TableCell>
                        <TableCell sx={{ textAlign: "left" }}>
                          {row.shop_order_no}
                        </TableCell>
                        <TableCell sx={{ textAlign: "left" }}>
                          {row.shop_order_item_no}
                        </TableCell>
                        <TableCell sx={{ textAlign: "left" }}>
                          {row.shop_order_item_name}
                        </TableCell>
                        <TableCell sx={{ textAlign: "left" }}>
                          {row.shop_order_item_size
                            ? row.shop_order_item_size
                            : "-"}
                        </TableCell>
                        <TableCell sx={{ textAlign: "left" }}>
                          {row.shop_order_unit}
                        </TableCell>
                        {/* <TableCell sx={{ textAlign: "left" }}>
                          <TextField
                            size="small"
                            type="number"
                            sx={{ width: "70%" }}
                            inputProps={{ max: row?.balance_quantity, min: 0 }}
                            onKeyDown={(e) => {
                              const inputValue = parseInt(
                                e.target.value + e.key,
                                10
                              );
                              if (
                                isNaN(inputValue) ||
                                inputValue > row?.balance_quantity
                              ) {
                                e.preventDefault();
                              }
                            }}
                            onChange={(e) => {
                              handleSelect(e, row, i, "shop");
                            }}
                          />
                        </TableCell> */}
                        <TableCell>
                          <TextField
                            size="small"
                            type="number"
                            sx={{ width: "70%" }}
                            disabled={itemDetails?.[i]?.inventory_status === true}
                            value={itemDetails?.[i]?.dispatch_quantity || null}
                            inputProps={{ max: row?.balance_quantity, min: 0 }}
                            onKeyDown={(e) => {
                              const inputValue = parseInt(
                                e.target.value + e.key,
                                10
                              );
                              if (
                                isNaN(inputValue) ||
                                inputValue > row?.balance_quantity
                              ) {
                                e.preventDefault();
                              }
                            }}
                            onChange={(e) => {
                              const value = Number(e.target.value)
                              if(value > row?.balance_quantity){
                                e.target.value = row?.balance_quantity
                                return;
                              }
                              handleSelect(e, row, i, "shop");
                            }}
                          />
                          {itemDetails?.[i]?.inventory_status === true && (
                            <LoadingButton
                              fullWidth
                              // loading={editLoader}
                              size="small"
                              variant="contained"
                              sx={{ mt: 1, fontSize: "10px", width: "70%" }}
                              onClick={() => {
                                handleInventoryEdit(row, i);
                              }}
                            >
                              Edit
                            </LoadingButton>
                          )}
                        </TableCell>
                        <TableCell>
                          {itemDetails?.[i]?.inventory_status === false ? <Button
                            size="small"
                            variant="contained"
                            sx={{ mt: 1, fontSize: "10px" }}
                            disabled={!itemDetails?.[i]?.dispatch_quantity}
                            onClick={() => handleInventoryCheck(row, i)}
                          >Check</Button> : <Typography variant="h5">{itemDetails?.[i]?.is_dispatch ? "Available" : "Not Available"}</Typography>}
                        </TableCell>
                        <TableCell sx={{ textAlign: "left" }}>
                          {row.shop_order_item_require_quantity}
                        </TableCell>
                        <TableCell sx={{ textAlign: "left" }}>
                          {row.balance_quantity}
                        </TableCell>
                        {/* <TableCell sx={{ textAlign: "left" }}>
                          {row.available_quantity}
                        </TableCell> */}

                        <TableCell sx={{ textAlign: "left" }}>
                          <TextareaAutosize
                            contentEditable={false}
                            maxRows={4}
                            value={row.shop_order_item_remarks}
                          />
                        </TableCell>
                        <TableCell sx={{ textAlign: "left" }}>
                          <TextareaAutosize
                            contentEditable={false}
                            maxRows={4}
                            value={row.shop_order_remarks}
                          />
                        </TableCell>
                        <TableCell sx={{ textAlign: "left" }}>
                          {row.shop_order_client_name}
                        </TableCell>
                        <TableCell sx={{ textAlign: "left" }}>
                          {displayDateFun(row.shop_order_date)}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Div>
          )}

          <Div>
            <Div sx={{ display: "flex", columnGap: 3, mt: 3 }}>
              <Typography variant="h4">Dispatch Id :</Typography>
              <Typography variant="h4">{dispatchId}</Typography>
            </Div>

            <Div
              sx={{
                display: "flex",
                columnGap: 2,
                mt: 1,
                alignItems: "center",
              }}
            >
              <Typography variant="h4" sx={{ mt: 1 }}>
                Shipment No:
              </Typography>
              <TextField
                onChange={handleChange}
                size="small"
                value={inputs?.dispatch_shipment_no || ""}
                name="dispatch_shipment_no"
              />
            </Div>

            <Div
              sx={{
                mt: 2,
                display: "flex",
                columnGap: 5,
                rowGap: 2,
                flexWrap: "wrap",
              }}
            >
              <Div sx={{ width: "23%" }}>
                <Typography variant="h5">Transport Type</Typography>
                <Select
                  size="small"
                  sx={{ width: "100%" }}
                  name="transport_type"
                  onChange={handleChange}
                  value={inputs?.transport_type || ""}
                >
                  <MenuItem value={"Hand"}>{"Hand"}</MenuItem>
                  <MenuItem value={"Air"}>{"Air"}</MenuItem>
                  <MenuItem value={"Sea"}>{"Sea"}</MenuItem>
                  <MenuItem value={"DHL"}>{"DHL"}</MenuItem>
                </Select>
              </Div>
              <Div sx={{ width: "23%" }}>
                <Typography variant="h5">Box No</Typography>
                <TextField
                  onChange={handleChange}
                  size="small"
                  fullWidth
                  value={inputs?.dispatch_box_no || ""}
                  name="dispatch_box_no"
                />
              </Div>
              <Div sx={{ width: "23%" }}>
                <Typography variant="h5">Weight (Kg)</Typography>
                <TextField
                  type="number"
                  onChange={handleChange}
                  size="small"
                  fullWidth
                  value={inputs?.dispatch_weight || ""}
                  name="dispatch_weight"
                />
              </Div>
              {inputs?.dispatch_type == "Normal Order" ? (
                <Div sx={{ width: "23%" }}>
                  <Typography variant="h5">Quantity</Typography>
                  <TextField
                    onChange={handleChange}
                    disabled
                    size="small"
                    fullWidth
                    value={
                      itemDetails.filter((item) => {
                        return item != undefined;
                      }).length
                    }
                    name="dispatch_quantity"
                  />
                </Div>
              ) : (
                <Div sx={{ width: "23%" }}>
                  <Typography variant="h5">Quantity</Typography>
                  {/* {console.log(inputs, "rrrrrrrrrrrrrrrrrr")} */}
                  <TextField
                    // onChange={handleChange}
                    disabled
                    size="small"
                    fullWidth
                    value={itemDetails
                      ?.filter((item) => item !== null)
                      .reduce((a, item) => {
                        return a + (item?.dispatch_quantity || 0);
                      }, 0)}
                    name="dispatch_quantity"
                  />
                </Div>
              )}
              {inputs.transport_type == "Hand" ? (
                <>
                  <Div sx={{ width: "23%" }}>
                    <Typography variant="h5">Contact Person Name</Typography>
                    <TextField
                      onChange={handleChange}
                      size="small"
                      fullWidth
                      value={inputs?.dispatch_contact_person_name || ""}
                      name="dispatch_contact_person_name"
                    />
                  </Div>
                  <Div sx={{ width: "23%" }}>
                    <Typography variant="h5">Contact Person No.</Typography>
                    <TextField
                      onChange={handleChange}
                      size="small"
                      fullWidth
                      value={inputs?.dispatch_contact_person_phone_no || ""}
                      name="dispatch_contact_person_phone_no"
                    />
                  </Div>
                </>
              ) : (
                <Div sx={{ width: "23%" }}>
                  <Typography variant="h5">AWB / BL No.</Typography>
                  <TextField
                    onChange={handleChange}
                    size="small"
                    fullWidth
                    value={inputs?.awb_bl_no || ""}
                    name="awb_bl_no"
                  />
                </Div>
              )}
            </Div>
            <Div sx={{ display: "flex", columnGap: 2, width: "40%", mt: 2 }}>
              <Div>
                <Typography variant="h5">Date of Dispatch</Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    format="DD/MM/YY"
                    // maxDate={dayjs()}
                    defaultValue={dayjs(inputs?.dispatch_date || currentdate)}
                    onChange={(date) => (inputs.dispatch_date = dateFun(date))}
                    sx={{
                      width: "100%",
                      "&.MuiTextField-root": {
                        height: "39px",
                        flexDirection: "unset",
                      },
                    }}
                  />
                </LocalizationProvider>
              </Div>
              <Div>
                <Typography variant="h5">Est. Delivery Date</Typography>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    // minDate={dayjs()}
                    format="DD/MM/YY"
                    defaultValue={dayjs(inputs?.dispatch_est_delivery_date)}
                    onChange={(date) =>
                      (inputs.dispatch_est_delivery_date = dateFun(date))
                    }
                    sx={{
                      width: "100%",
                      "&.MuiTextField-root": {
                        height: "39px",
                        flexDirection: "unset",
                      },
                    }}
                  />
                </LocalizationProvider>
              </Div>
            </Div>
          </Div>
        </>
      )}
      <Div
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: 3,
          mt: 4,
        }}
      >
        <Button
          variant="outlined"
          onClick={() => {
            Swal.fire({
              title: "Are you sure you want to cancel?",
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: "Yes",
              cancelButtonText: "No",
            }).then((result) => {
              if (result.isConfirmed) {
                revertInventory();
                navigate("/dashboard/order/dispatch");
              }
            });
          }}
        >
          Cancel
        </Button>
        {/* {console.log(itemDetails)} */}
        <LoadingButton
          disabled={
            itemDetails.length > 0 &&
              itemDetails.filter((item) => item != undefined).length > 0
              ? false
              : true
          }
          variant="contained"
          sx={{ width: "100px" }}
          onClick={submitForm}
          loading={submitLoader}
        >
          Dispatch
        </LoadingButton>
      </Div>
    </Div>
  );
};

export default CreateNewDispatch;
